import { Component, input, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ReportControl } from '@xmedical/core';
import { XmedicalUiModule } from '@xmedical/ui';
import { TranscribeComponent } from '@xmedical/transcribe';

@Component({
  selector: 'xmed-multi-line-text-field-renderer',
  standalone: true,
  imports: [
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    XmedicalUiModule,
    TranscribeComponent
  ],
  templateUrl: './multi-line-text-field-renderer.component.html',
  styleUrl: './multi-line-text-field-renderer.component.scss'
})
export class MultiLineTextFieldRendererComponent {
  control = input.required<ReportControl>();

  valueChanged = output<void>();

  onTextReceived(text: string): void {
    this.control().value += text;
    this.valueChanged.emit();
  }

  onValueChanges(): void {
    this.valueChanged.emit();
  }
}
